import { render, staticRenderFns } from "./EducationalJoiningApplicationCards.vue?vue&type=template&id=a4006b84&"
import script from "./EducationalJoiningApplicationCards.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports